import { render } from "./Inicio.vue?vue&type=template&id=bbb1050e&scoped=true"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"

import "./Inicio.vue?vue&type=style&index=0&id=bbb1050e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb1050e"]])

export default __exports__